import React from 'react';
interface GlassButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  type?: 'button' | 'submit';
  variant?: 'primary' | 'secondary';
  className?: string;
  disabled?: boolean;
}
export function GlassButton({
  children,
  onClick,
  type = 'button',
  variant = 'primary',
  className = '',
  disabled = false
}: GlassButtonProps) {
  const baseStyles = 'px-6 py-3 rounded-2xl font-medium transition-all duration-300 backdrop-blur-xl border';
  const variantStyles = {
    primary: 'bg-gradient-to-r from-purple-400/40 to-pink-400/40 border-white/40 hover:from-purple-400/60 hover:to-pink-400/60 text-white shadow-lg hover:shadow-xl',
    secondary: 'bg-white/20 border-white/30 hover:bg-white/30 text-white shadow-md hover:shadow-lg'
  };
  return <button type={type} onClick={onClick} disabled={disabled} className={`${baseStyles} ${variantStyles[variant]} ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`} data-id="element-37">
      {children}
    </button>;
}